module.exports = __webpack_public_path__ + "media/libro_animation.bc373cc0.webm";